<template>
  <div>
    <h1>{{ local.errorPages.pageNotFound.title }}</h1>
    <back-button></back-button>
  </div>
</template>

<script>
import BackButton from './back-button';

export default {
  components: { BackButton },
};
</script>
